import { useState } from 'react'
import { Popover, MenuItem, Avatar } from '../ds/index.js'
import { AVATAR_PALETTE } from '../lib/format.js'

// Quick avatar menu: identity, avatar color, theme, Settings link, sign out.
// The full Settings page (#/settings) is the source of truth; this is a shortcut.
export default function AccountMenu({ user, updateProfile, signOut, theme, onToggleTheme, onOpenSettings }) {
  const [open, setOpen] = useState(false)
  return (
    <div className="cn-popover-wrap" style={{ position: 'relative' }}>
      <button onClick={() => setOpen((v) => !v)} style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'none', border: 'none', cursor: 'pointer', padding: 6, width: '100%' }}>
        <Avatar user={user} size={28} />
        <span style={{ fontSize: 13, color: 'var(--color-white)', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{user.name}</span>
      </button>
      <Popover open={open} onClose={() => setOpen(false)} align="left" placement="up">
        <div style={{ padding: '8px 10px', borderBottom: '1px solid var(--color-divider-dark)' }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--color-white)' }}>{user.name}</div>
          <div className="font-mono" style={{ fontSize: 11, color: 'var(--color-muted)' }}>{user.email}</div>
        </div>
        <div style={{ padding: '8px 10px', display: 'flex', gap: 6 }}>
          {AVATAR_PALETTE.map((c) => (
            <button key={c.color} onClick={() => updateProfile({ color: c.color, ink: c.ink })} title={c.color}
              style={{ width: 22, height: 22, borderRadius: '50%', background: c.color, border: 'none', cursor: 'pointer', outline: c.color === user.color ? '2px solid var(--color-gold)' : '2px solid transparent', outlineOffset: 2 }} />
          ))}
        </div>
        <MenuItem onClick={() => { onToggleTheme(); }}>{theme === 'light' ? 'Switch to dark' : 'Switch to light'}</MenuItem>
        <MenuItem onClick={() => { setOpen(false); onOpenSettings() }}>Settings</MenuItem>
        <MenuItem danger onClick={signOut}>Sign out</MenuItem>
      </Popover>
    </div>
  )
}
